export function getAppModel<T>(container: HTMLElement, attribute = ""): T {
  const stringifiedModel = container.dataset[attribute] ?? container.dataset.desAppModel ?? "";

  try {
    return JSON.parse(stringifiedModel) as T;
  } catch (e) {
    console.error(e);
    return {} as T;
  }
}
